(ns manatee.scoring-criteria
  "Suppress certain scoring criteria for particular questions as defined in the task-config.")

(defn- part-and-question-number?
  "Return 'true' if the scoring criterion is suppressed by part and question number."
  [scoring-criterion suppressions part-number question-number]
  (seq (filter (fn [suppression]
                 (let [suppressed-part-number (:part suppression)
                       suppressed-question-numbers (:questions suppression)
                       suppressed-criteria (set (mapv keyword (:criteria suppression)))]
                   (and (= part-number suppressed-part-number)
                        (contains? (set suppressed-question-numbers) question-number)
                        (contains? (set suppressed-criteria) (:name scoring-criterion)))))
               suppressions)))

(defn- question-id?
  "Return 'true' id the scoring criterion is suppressed by question id."
  [scoring-criterion suppressions question-id]
  (seq (filter (fn [suppression]
                 (let [suppressed-question-ids (:question-ids suppression)
                       suppressed-criteria (set (mapv keyword (:criteria suppression)))]
                   (and
                    suppressed-question-ids
                    (contains? (set suppressed-question-ids) (str question-id))
                    (contains? (set suppressed-criteria) (:name scoring-criterion)))))
               suppressions)))

(defn- speaking-time?
  "Return 'true' speaking-time the scoring criterion is suppressed by speaking-time."
  [scoring-criterion suppressions speaking-time]
  (seq (filter (fn [suppression]
                 (let [suppressed-speaking-time (:speaking-time suppression)
                       suppressed-criteria (set (mapv keyword (:criteria suppression)))]
                   (and
                    suppressed-speaking-time
                    (= suppressed-speaking-time speaking-time)
                    (contains? (set suppressed-criteria) (:name scoring-criterion)))))
               suppressions)))

(defn- ignore-scoring-criterion?
  "Return 'true' if a scoring criterion should be suppressed.
  The task-config/criteria-suppression defines if the scoring criterion should be suppressed by any of these ways:
    * Matching the part number & question number
    * Matching the question ID
    * Matching the question speaking time"
  [scoring-criterion {:keys [question-number id part speaking-time]} suppressions]
  (let [part-number (:number part)]
    (or
     (part-and-question-number? scoring-criterion suppressions part-number question-number)
     (question-id? scoring-criterion suppressions id)
     (speaking-time? scoring-criterion suppressions speaking-time))))

(defn remove-certain-scoring-criteria
  "Remove the scoring criteria for certain questions as defined in the task-config."
  [question task-config scoring-criteria]
  (let [fields (get-in task-config [:data :answer :fields])
        suppressions (->> (filter :criteria-suppression fields)
                          first
                          :criteria-suppression)]
    (remove #(ignore-scoring-criterion? % question suppressions)
            scoring-criteria)))
